module.exports = __webpack_public_path__ + "img/momo_index_button_3.91161d42.png";